import { render, staticRenderFns } from "./BannerBlock.vue?vue&type=template&id=b7cde368"
import script from "./BannerBlock.vue?vue&type=script&lang=ts"
export * from "./BannerBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports